import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import AuthContext from '../../App/authContext';
import ModalBody from './ModalBody';
import ModalBody1 from './ModalBody1';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = ({modalVisible, setModalVisible, modalVisible1, setModalVisible1}) => {
  const [results, setResults] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [update, setUpdate] = useState(0);

  const history = useHistory();
  const dispatch = useDispatch();
  const func = useContext(AuthContext);
  const [form] = Form.useForm();
  const { confirm } = Modal;

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('id');

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', userId);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/get_restaurant.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        localStorage.clear();
        alert(res.data.Message);
        history.push('/login');
        func();
      }
    }catch(error) {
      console.log(error);

    }
  }

  const openEditModal = (restaurant) => {
    setUpdate(update + 1);
    setEditModalVisible(true);
    setSelectedRestaurant(restaurant);
  }

  const handleSubmit = async (values, index) => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', userId);
    bodyFormData.append('Token', token);
    bodyFormData.append('Name', values.name);
    bodyFormData.append('Address', values.adderss);
    bodyFormData.append('Lat', values.lat);
    bodyFormData.append('Lng', values.lng);
    bodyFormData.append('Review', values.verified);

    try {
      if(index === 0) {
        setModalVisible(false);
        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/add_restaurant.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }else {
        setEditModalVisible(false);
        bodyFormData.append('RestaurantId', selectedRestaurant.Id);
        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/update_restaurant.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }
    } catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const handleSubmit1 = async (values) => {
    dispatch(enableSpinner('Importing..'));
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('UserId', userId);
      bodyFormData.append('Token', token);
      bodyFormData.append('file', values.file);

      const res = await axios.post(`${URL}/import_csv.php`, bodyFormData);
      if(res.data.Success) {
        setModalVisible1(false);
        alert(res.data.Message);
        loadResults();
      } else {
        alert(res.data.Message);
      }
    } catch(error) {

    }
    dispatch(disableSpinner());
  }

  const handleDeleteRestaurant = (restaurant) => {
    confirm({
      title: 'Are you sure delete this sticker?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteRestaurant(restaurant.Id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteRestaurant = async (restaurantId) => {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');

    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('RestaurantId', restaurantId);
    try {
      dispatch(enableSpinner('Deleting..'));
      const res = await axios.post(`${URL}/delete_restaurant.php`, bodyFormData);
      dispatch(disableSpinner());
      if(res.data.Success) {
        alert(res.data.Message);
        loadResults();
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Address',
      dataIndex: 'Address',
      key: 'Address',
    },
    {
      title: 'Lat',
      dataIndex: 'Lat',
      key: 'Lat'
    },
    {
      title: 'Lng',
      dataIndex: 'Lng',
      key: 'Lng'
    },
    {
      title: 'Verified',
      dataIndex: 'Review',
      key: 'Review',
      render: ((value) => (
        <div> 
          <span>{value == 0?'No':'Yes'}</span>
        </div>
      ))
    },
    {
      title: 'Edit',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => openEditModal(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          Edit
          </span>
        )
      }
    },
    {
      title: 'Delete',
      dataIndex: '',
      key: 'delete',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => handleDeleteRestaurant(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <DeleteOutlined />
          </span>
        )
      }
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
      <Modal
        title={`Add Restaurant`}
        width="30%"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        footer={null}
      >
        <ModalBody close={() => setModalVisible(false)} handleSubmit={(values) => handleSubmit(values, 0)} />
      </Modal>
      <Modal 
        title="Edit Restaurant"
        width="30%"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}>
          <ModalBody 
            close={() => {setSelectedRestaurant(null); setEditModalVisible(false); }} 
            handleSubmit={(values) => handleSubmit(values, 1)}
            restaurant={selectedRestaurant}
            update={update} />
      </Modal>

      <Modal
        title={`Import Excel`}
        width="30%"
        visible={modalVisible1}
        onCancel={() => setModalVisible1(false)}
        onOk={() => setModalVisible1(false)}
        footer={null}
      >
        <ModalBody1 close={() => setModalVisible1(false)} handleSubmit1={(values) => handleSubmit1(values)} />
      </Modal>
    </Col>
  );
}



export default ExampleCard;
